import { match, P } from 'ts-pattern'
import { Text } from './text'
import { NumberRenderer } from './number'
import { Dates } from './date'
import { DefaultDataGridCells, RendererMap, RenderProps } from '../types'
import { Enums } from './enum'
import { Files } from './file'
import { Link } from './link'
import { Skeletons } from './skeleton'
import { Booleans } from './boolean'
import { ObjectRenderer } from './object'

export const CellRenderer = <Cell extends DefaultDataGridCells>({
  renderers,
  mode = 'view',
  ...props
}: RenderProps<Cell, any> & { renderers?: RendererMap }) => {
  const { column, row } = props

  const cellProps = row[column.key as keyof Cell] as DefaultDataGridCells
  return match(cellProps)
    .with({ type: 'string' }, (cell) => <Text mode={mode} {...props} cell={cell} />)
    .with({ type: 'number' }, (cell) => <NumberRenderer mode={mode} {...props} cell={cell} />)
    .with({ type: 'boolean' }, (cell) => <Booleans mode={mode} {...props} cell={cell} />)
    .with({ type: 'enum' }, (cell) => <Enums mode={mode} {...props} cell={cell} />)
    .with({ type: 'url' }, (cell) => <Link mode={mode} {...props} cell={cell} />)
    .with({ type: 'file' }, (cell) => <Files mode={mode} {...props} cell={cell} />)
    .with({ type: 'date' }, (cell) => <Dates mode={mode} {...props} cell={cell} />)
    .with({ type: 'object' }, (cell) => <ObjectRenderer mode={mode} {...props} cell={cell} />)
    .with({ type: 'skeleton' }, (cell) => <Skeletons mode={mode} {...props} cell={cell} />)
    .with({ type: 'empty' }, () => null)
    .with(
      { type: P.string },
      (cell) => renderers?.[cell.type]?.View?.({ ...props, ...cell, mode }) ?? <p>Unknown cell type: {cell.type}</p>
    )
    .otherwise((data) => {
      console.error('Unknown cell type', data)
      return null
    })
}

export * from './renderer'
export * from './text'
export * from './null'
export * from './number'
export * from './date'
export * from './boolean'
export * from './link'
export * from './skeleton'
export * from './boolean'
